import { styled } from "@mui/system";

export const BlogDetailWrapper = styled("div")(() => ({}));

export const BlogHero = styled("div")(() => ({
  paddingTop: 40,
  marginBottom: 32,
}));

export const BlogTitle = styled("h1")(() => ({
  fontSize: 36,
  fontWeight: 800,
  lineHeight: 1.3,
  marginBottom: 16,
}));

export const BlogMeta = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
  color: "#6b7280",
  fontSize: 14,
}));

export const AuthorAvatar = styled("img")(() => ({
  width: 36,
  height: 36,
  borderRadius: "50%",
}));

export const BlogCover = styled("div")(() => ({
  margin: "32px 0",
  height: 320,
  borderRadius: 20,
  background: "linear-gradient(135deg, #9333ea 0%, #2563eb 100%)",
}));

export const BlogContent = styled("div")(() => ({
  fontSize: 16,
  lineHeight: 1.75,
  color: "#111827",

  "& h2": {
    fontSize: 24,
    fontWeight: 700,
    margin: "32px 0 16px",
  },

  "& p": {
    marginBottom: 16,
    color: "#374151",
  },

  "& ul": {
    paddingLeft: 20,
    marginBottom: 16,
  },

  "& li": {
    marginBottom: 8,
  },

  "& blockquote": {
    borderLeft: "4px solid #2563eb",
    paddingLeft: 16,
    color: "#4b5563",
    fontStyle: "italic",
    margin: "24px 0",
  },

  "& img": {
    maxWidth: "100%",
    height: "auto",
    margin: "16px 0",
  },

  "& h1": {
    fontSize: 32,
    fontWeight: 800,
    margin: "32px 0 16px",
  },

  "& h3": {
    fontSize: 20,
    fontWeight: 600,
    margin: "24px 0 12px",
  },

  "& h4": {
    fontSize: 18,
    fontWeight: 600,
    margin: "20px 0 10px",
  },

  "& ol li[data-list='bullet']": {
    listStyleType: "disc",
  },

  "& ol li[data-list='ordered']": {
    listStyleType: "decimal",
  },

  /* ================= TABLE ================= */

  "& table": {
    width: "100%",
    borderCollapse: "collapse",
    margin: "16px 0",
    overflowX: "auto",
  },

  "& th, & td": {
    border: "1px solid #d1d5db",
    padding: "8px 12px",
    verticalAlign: "top",
  },

  "& th": {
    background: "#f3f4f6",
    fontWeight: 600,
  },

  "& tr:nth-of-type(even)": {
    background: "#fafafa",
  },

  /* ================= CODE ================= */

  "& pre": {
    background: "#111827",
    color: "#f9fafb",
    padding: 16,
    borderRadius: 8,
    overflowX: "auto",
  },

  "& code": {
    background: "#f3f4f6",
    padding: "2px 4px",
    borderRadius: 4,
    fontSize: "0.9em",
  },
}));

export const RelatedWrapper = styled("div")(() => ({
  margin: "40px 0 60px",
}));

export const RelatedTitle = styled("h3")(() => ({
  fontSize: 22,
  fontWeight: 700,
  marginBottom: 24,
}));

export const RelatedGrid = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  gap: 24,
}));

export const RelatedCard = styled("a")(() => ({
  display: "flex",
  flexDirection: "column",
  background: "#fff",
  borderRadius: 12,
  overflow: "hidden",
  textDecoration: "none",
  color: "#111",
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
  transition: "transform .2s ease",
  height: "100%",
  "&:hover": {
    transform: "translateY(-4px)",
  },
}));
export const RelatedThumb = styled("img")(() => ({
  position: "absolute",
  objectFit: "cover",
  width: "100%",
  height: "100%",
  top: 0,
}));

export const RelatedContent = styled("div")(() => ({
  padding: 20,
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export const RelatedPostTitle = styled("h3")(() => ({
  fontSize: 18,
  fontWeight: 600,
  marginBottom: 8,

  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

export const RelatedPostDesc = styled("p")(() => ({
  fontSize: 14,
  color: "#6b7280",
  marginBottom: 12,

  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

export const RelatedMeta = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
  color: "#9ca3af",
  marginTop: "auto",
}));
